import DQFormCard from "./DQFormCard";

export default DQFormCard;
